import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    item: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    pageCount: {
      color: COLORS.gray.gray40,
    },
    selected: {
      backgroundColor: 'unset',
    },
    paper: {
      maxHeight: 276,
    },
  }),
  { name: 'SelectResourceFile' }
);
